// SurgeryList.js

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSurgeries } from '../../utils/FirebaseFunctions';

const SurgeryList = () => {
  const [selectedArea, setSelectedArea] = useState('All');
  const [surgeriesData, setSurgeriesData] = useState([])
  const navigate = useNavigate()
  const uniqueAreas = ['All', ...new Set(surgeriesData.map((surgery) => surgery.area))];

  const handleFilterChange = (area) => {
    setSelectedArea(area);
  };

  useEffect(() => {
    getSurgeries().then((data) => {
      setSurgeriesData(data)
    })
  }, [])

  const filteredSurgeries = selectedArea === 'All' ? surgeriesData : surgeriesData.filter((surgery) => surgery.area === selectedArea);

  // Group surgeries by area
  const groupedSurgeries = {};
  surgeriesData.forEach((surgery) => {
    if (!groupedSurgeries[surgery.area]) {
      groupedSurgeries[surgery.area] = [];
    }
    groupedSurgeries[surgery.area].push(surgery);
  });

  return (
    <div className="container w-screen mt-8 p-5">
      {/* <div className="flex w-full items-center justify-between mb-4">
        <div className="flex p-5 py-3 bg-white mt-[30px] w-screen fixed left-[0px] overflow-auto gap-[5px]">
          {uniqueAreas.map((area) => (
            <button
              key={area}
              onClick={() => handleFilterChange(area)}
              className={`py-3 px-5 text-xs rounded ${
                selectedArea === area ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'
              }`}
            >
              {area}
            </button>
          ))}
        </div>
      </div>
      <div className="h-[50px] w-full"></div> */}

      {selectedArea === 'All' ? (
        Object.keys(groupedSurgeries).map((area) => (
          <div key={area} className="mb-8 scrollbar-hidden">
            <p className="text-lg font-semibold mb-4">{area}</p>
            <div className='flex flex-row gap-[10px] ml-[-20px] px-[20px] scrollbar-hidden flex-nowrap w-screen overflow-auto'>
            {groupedSurgeries[area].map((surgery) => (
              <div key={surgery?.id} className="scrollbar-hidden" style={{width: "280px"}}>
                <div className="bg-white p-4 rounded shadow scrollbar-hidden" style={{width: "280px"}}>
                  <div className='w-full h-[250px] bg-gray-100 mb-[20px] rounded-lg'>
                    <img src={surgery?.image} className='h-full w-full rounded-lg object-cover' alt="" />
                  </div>
                  <p className="text-xs"><span className='ml-[0px]'>{surgery?.name}</span></p>
                  <p className="text-xs mt-[5px]">Price: <span className='ml-[5px]'>{surgery?.price} USD</span></p>
                  <p className="text-xs mt-[5px]">Duration: <span className='ml-[5px]'> {surgery?.duration} Days</span></p>
                  <button onClick={() => navigate("/surgery/" + surgery?.id)} className='bg-[#0080f3] w-full h-[36px] rounded-md text-white mt-[20px] text-sm'>Book</button>
                </div>
              </div>
            ))}

            </div>
          </div>
        ))
      ) : (
        <div className="mb-8">
          <h2 className="text-lg font-semibold mb-2">{selectedArea}</h2>
          <div className='flex flex-row gap-[10px] ml-[-20px] px-[20px] flex-nowrap w-screen overflow-auto'>
            {filteredSurgeries.map((surgery) => (
              <div key={surgery?.id} className="scrollbar-hidden" style={{width: "280px"}}>
                <div className="bg-white p-4 rounded shadow scrollbar-hidden" style={{width: "280px"}}>
                  <div className='w-full h-[250px] bg-gray-100 mb-[20px] rounded-lg'>
                    <img src={surgery?.image} className='h-full w-full rounded-lg object-cover' alt="" />
                  </div>
                  <p className="text-xs"><span className='ml-[0px]'>{surgery?.name}</span></p>
                  <p className="text-xs mt-[5px]">Price: <span className='ml-[5px]'>{surgery?.price} USD</span></p>
                  <p className="text-xs mt-[5px]">Duration: <span className='ml-[5px]'> {surgery?.duration} Days</span></p>
                  <button onClick={() => navigate("/surgery/" + surgery?.id)} className='bg-[#0080f3] w-full h-[36px] rounded-md text-white mt-[20px] text-sm'>Book</button>
                </div>
              </div>
          ))}
          </div>
        </div>
      )}
    </div>
  );
};


export default SurgeryList;
